import { request } from "../fetch";

class ConvenioService {
  static async getAll(clinicaId) {
    return request(`api/adm/convenios/clinic/${clinicaId}`);
  }

  static async getById(id) {
    return request(`api/adm/convenios/${id}`);
  }

  static async create(data) {
    return request("api/adm/convenios", {
      method: "POST",
      body: JSON.stringify(data),
    });
  }

  static async update(id, data) {
    return request(`api/adm/convenios/${id}`, {
      method: "PUT",
      body: JSON.stringify(data),
    });
  }

  static async remove(id) {
    return request(`api/adm/convenios/${id}`, { method: "DELETE" });
  }

  static async getClinicas() {
    return request("api/adm/clinicas");
  }

  static async getTabelasProcedimentos(clinicaId) {
    if (!clinicaId) return [];
    return request(
      `api/adm/tabelaprocedimentos?clinicaId=${encodeURIComponent(clinicaId)}`,
    );
  }
}

export default ConvenioService;
